interface CitizenObject {
  citizenId: number;
  countryCode: string;
  country: string;
}

// eslint-disable-next-line max-lines-per-function
export const CITIZENSHIPS: CitizenObject[] = [
  {
    citizenId: 1,
    countryCode: 'AF',
    country: 'Afghanistan',
  },
  {
    citizenId: 2,
    countryCode: 'AL',
    country: 'Albania',
  },
  {
    citizenId: 3,
    countryCode: 'DZ',
    country: 'Algeria',
  },
  {
    citizenId: 4,
    countryCode: 'DS',
    country: 'American Samoa',
  },
  {
    citizenId: 5,
    countryCode: 'AD',
    country: 'Andorra',
  },
  {
    citizenId: 6,
    countryCode: 'AO',
    country: 'Angola',
  },
  {
    citizenId: 7,
    countryCode: 'AI',
    country: 'Anguilla',
  },
  {
    citizenId: 8,
    countryCode: 'AQ',
    country: 'Antarctica',
  },
  {
    citizenId: 9,
    countryCode: 'AG',
    country: 'Antigua and Barbuda',
  },
  {
    citizenId: 10,
    countryCode: 'AR',
    country: 'Argentina',
  },
  {
    citizenId: 11,
    countryCode: 'AM',
    country: 'Armenia',
  },
  {
    citizenId: 12,
    countryCode: 'AW',
    country: 'Aruba',
  },
  {
    citizenId: 13,
    countryCode: 'AU',
    country: 'Australia',
  },
  {
    citizenId: 14,
    countryCode: 'AT',
    country: 'Austria',
  },
  {
    citizenId: 15,
    countryCode: 'AZ',
    country: 'Azerbaijan',
  },
  {
    citizenId: 16,
    countryCode: 'BS',
    country: 'Bahamas',
  },
  {
    citizenId: 17,
    countryCode: 'BH',
    country: 'Bahrain',
  },
  {
    citizenId: 18,
    countryCode: 'BD',
    country: 'Bangladesh',
  },
  {
    citizenId: 19,
    countryCode: 'BB',
    country: 'Barbados',
  },
  {
    citizenId: 20,
    countryCode: 'BY',
    country: 'Belarus',
  },
  {
    citizenId: 21,
    countryCode: 'BE',
    country: 'Belgium',
  },
  {
    citizenId: 22,
    countryCode: 'BZ',
    country: 'Belize',
  },
  {
    citizenId: 23,
    countryCode: 'BJ',
    country: 'Benin',
  },
  {
    citizenId: 24,
    countryCode: 'BM',
    country: 'Bermuda',
  },
  {
    citizenId: 25,
    countryCode: 'BT',
    country: 'Bhutan',
  },
  {
    citizenId: 26,
    countryCode: 'BO',
    country: 'Bolivia',
  },
  {
    citizenId: 27,
    countryCode: 'BA',
    country: 'Bosnia and Herzegovina',
  },
  {
    citizenId: 28,
    countryCode: 'BW',
    country: 'Botswana',
  },
  {
    citizenId: 29,
    countryCode: 'BV',
    country: 'Bouvet Island',
  },
  {
    citizenId: 30,
    countryCode: 'BR',
    country: 'Brazil',
  },
  {
    citizenId: 31,
    countryCode: 'IO',
    country: 'British Indian Ocean Territory',
  },
  {
    citizenId: 32,
    countryCode: 'BN',
    country: 'Brunei Darussalam',
  },
  {
    citizenId: 33,
    countryCode: 'BG',
    country: 'Bulgaria',
  },
  {
    citizenId: 34,
    countryCode: 'BF',
    country: 'Burkina Faso',
  },
  {
    citizenId: 35,
    countryCode: 'BI',
    country: 'Burundi',
  },
  {
    citizenId: 36,
    countryCode: 'KH',
    country: 'Cambodia',
  },
  {
    citizenId: 37,
    countryCode: 'CM',
    country: 'Cameroon',
  },
  {
    citizenId: 38,
    countryCode: 'CA',
    country: 'Canada',
  },
  {
    citizenId: 39,
    countryCode: 'CV',
    country: 'Cape Verde',
  },
  {
    citizenId: 40,
    countryCode: 'KY',
    country: 'Cayman Islands',
  },
  {
    citizenId: 41,
    countryCode: 'CF',
    country: 'Central African Republic',
  },
  {
    citizenId: 42,
    countryCode: 'TD',
    country: 'Chad',
  },
  {
    citizenId: 43,
    countryCode: 'CL',
    country: 'Chile',
  },
  {
    citizenId: 44,
    countryCode: 'CN',
    country: 'China',
  },
  {
    citizenId: 45,
    countryCode: 'CX',
    country: 'Christmas Island',
  },
  {
    citizenId: 46,
    countryCode: 'CC',
    country: 'Cocos (Keeling) Islands',
  },
  {
    citizenId: 47,
    countryCode: 'CO',
    country: 'Colombia',
  },
  {
    citizenId: 48,
    countryCode: 'KM',
    country: 'Comoros',
  },
  {
    citizenId: 49,
    countryCode: 'CG',
    country: 'Congo',
  },
  {
    citizenId: 50,
    countryCode: 'CK',
    country: 'Cook Islands',
  },
  {
    citizenId: 51,
    countryCode: 'CR',
    country: 'Costa Rica',
  },
  {
    citizenId: 52,
    countryCode: 'HR',
    country: 'Croatia (Hrvatska)',
  },
  {
    citizenId: 53,
    countryCode: 'CU',
    country: 'Cuba',
  },
  {
    citizenId: 54,
    countryCode: 'CY',
    country: 'Cyprus',
  },
  {
    citizenId: 55,
    countryCode: 'CZ',
    country: 'Czech Republic',
  },
  {
    citizenId: 56,
    countryCode: 'DK',
    country: 'Denmark',
  },
  {
    citizenId: 57,
    countryCode: 'DJ',
    country: 'Djibouti',
  },
  {
    citizenId: 58,
    countryCode: 'DM',
    country: 'Dominica',
  },
  {
    citizenId: 59,
    countryCode: 'DO',
    country: 'Dominican Republic',
  },
  {
    citizenId: 60,
    countryCode: 'TP',
    country: 'East Timor',
  },
  {
    citizenId: 61,
    countryCode: 'EC',
    country: 'Ecuador',
  },
  {
    citizenId: 62,
    countryCode: 'EG',
    country: 'Egypt',
  },
  {
    citizenId: 63,
    countryCode: 'SV',
    country: 'El Salvador',
  },
  {
    citizenId: 64,
    countryCode: 'GQ',
    country: 'Equatorial Guinea',
  },
  {
    citizenId: 65,
    countryCode: 'ER',
    country: 'Eritrea',
  },
  {
    citizenId: 66,
    countryCode: 'EE',
    country: 'Estonia',
  },
  {
    citizenId: 67,
    countryCode: 'ET',
    country: 'Ethiopia',
  },
  {
    citizenId: 68,
    countryCode: 'FK',
    country: 'Falkland Islands (Malvinas)',
  },
  {
    citizenId: 69,
    countryCode: 'FO',
    country: 'Faroe Islands',
  },
  {
    citizenId: 70,
    countryCode: 'FJ',
    country: 'Fiji',
  },
  {
    citizenId: 71,
    countryCode: 'FI',
    country: 'Finland',
  },
  {
    citizenId: 72,
    countryCode: 'FR',
    country: 'France',
  },
  {
    citizenId: 73,
    countryCode: 'FX',
    country: 'France, Metropolitan',
  },
  {
    citizenId: 74,
    countryCode: 'GF',
    country: 'French Guiana',
  },
  {
    citizenId: 75,
    countryCode: 'PF',
    country: 'French Polynesia',
  },
  {
    citizenId: 76,
    countryCode: 'TF',
    country: 'French Southern Territories',
  },
  {
    citizenId: 77,
    countryCode: 'GA',
    country: 'Gabon',
  },
  {
    citizenId: 78,
    countryCode: 'GM',
    country: 'Gambia',
  },
  {
    citizenId: 79,
    countryCode: 'GE',
    country: 'Georgia',
  },
  {
    citizenId: 80,
    countryCode: 'DE',
    country: 'Germany',
  },
  {
    citizenId: 81,
    countryCode: 'GH',
    country: 'Ghana',
  },
  {
    citizenId: 82,
    countryCode: 'GI',
    country: 'Gibraltar',
  },
  {
    citizenId: 83,
    countryCode: 'GK',
    country: 'Guernsey',
  },
  {
    citizenId: 84,
    countryCode: 'GR',
    country: 'Greece',
  },
  {
    citizenId: 85,
    countryCode: 'GL',
    country: 'Greenland',
  },
  {
    citizenId: 86,
    countryCode: 'GD',
    country: 'Grenada',
  },
  {
    citizenId: 87,
    countryCode: 'GP',
    country: 'Guadeloupe',
  },
  {
    citizenId: 88,
    countryCode: 'GU',
    country: 'Guam',
  },
  {
    citizenId: 89,
    countryCode: 'GT',
    country: 'Guatemala',
  },
  {
    citizenId: 90,
    countryCode: 'GN',
    country: 'Guinea',
  },
  {
    citizenId: 91,
    countryCode: 'GW',
    country: 'Guinea-Bissau',
  },
  {
    citizenId: 92,
    countryCode: 'GY',
    country: 'Guyana',
  },
  {
    citizenId: 93,
    countryCode: 'HT',
    country: 'Haiti',
  },
  {
    citizenId: 94,
    countryCode: 'HM',
    country: 'Heard and Mc Donald Islands',
  },
  {
    citizenId: 95,
    countryCode: 'HN',
    country: 'Honduras',
  },
  {
    citizenId: 96,
    countryCode: 'HK',
    country: 'Hong Kong',
  },
  {
    citizenId: 97,
    countryCode: 'HU',
    country: 'Hungary',
  },
  {
    citizenId: 98,
    countryCode: 'IS',
    country: 'Iceland',
  },
  {
    citizenId: 99,
    countryCode: 'IN',
    country: 'India',
  },
  {
    citizenId: 100,
    countryCode: 'IM',
    country: 'Isle of Man',
  },
  {
    citizenId: 101,
    countryCode: 'ID',
    country: 'Indonesia',
  },
  {
    citizenId: 102,
    countryCode: 'IR',
    country: 'Iran (Islamic Republic of)',
  },
  {
    citizenId: 103,
    countryCode: 'IQ',
    country: 'Iraq',
  },
  {
    citizenId: 104,
    countryCode: 'IE',
    country: 'Ireland',
  },
  {
    citizenId: 105,
    countryCode: 'IL',
    country: 'Israel',
  },
  {
    citizenId: 106,
    countryCode: 'IT',
    country: 'Italy',
  },
  {
    citizenId: 107,
    countryCode: 'CI',
    country: 'Ivory Coast',
  },
  {
    citizenId: 108,
    countryCode: 'JE',
    country: 'Jersey',
  },
  {
    citizenId: 109,
    countryCode: 'JM',
    country: 'Jamaica',
  },
  {
    citizenId: 110,
    countryCode: 'JP',
    country: 'Japan',
  },
  {
    citizenId: 111,
    countryCode: 'JO',
    country: 'Jordan',
  },
  {
    citizenId: 112,
    countryCode: 'KZ',
    country: 'Kazakhstan',
  },
  {
    citizenId: 113,
    countryCode: 'KE',
    country: 'Kenya',
  },
  {
    citizenId: 114,
    countryCode: 'KI',
    country: 'Kiribati',
  },
  {
    citizenId: 115,
    countryCode: 'KP',
    country: "Korea, Democratic People's Republic of",
  },
  {
    citizenId: 116,
    countryCode: 'KR',
    country: 'Korea, Republic of',
  },
  {
    citizenId: 117,
    countryCode: 'XK',
    country: 'Kosovo',
  },
  {
    citizenId: 118,
    countryCode: 'KW',
    country: 'Kuwait',
  },
  {
    citizenId: 119,
    countryCode: 'KG',
    country: 'Kyrgyzstan',
  },
  {
    citizenId: 120,
    countryCode: 'LA',
    country: "Lao People's Democratic Republic",
  },
  {
    citizenId: 121,
    countryCode: 'LV',
    country: 'Latvia',
  },
  {
    citizenId: 122,
    countryCode: 'LB',
    country: 'Lebanon',
  },
  {
    citizenId: 123,
    countryCode: 'LS',
    country: 'Lesotho',
  },
  {
    citizenId: 124,
    countryCode: 'LR',
    country: 'Liberia',
  },
  {
    citizenId: 125,
    countryCode: 'LY',
    country: 'Libyan Arab Jamahiriya',
  },
  {
    citizenId: 126,
    countryCode: 'LI',
    country: 'Liechtenstein',
  },
  {
    citizenId: 127,
    countryCode: 'LT',
    country: 'Lithuania',
  },
  {
    citizenId: 128,
    countryCode: 'LU',
    country: 'Luxembourg',
  },
  {
    citizenId: 129,
    countryCode: 'MO',
    country: 'Macau',
  },
  {
    citizenId: 130,
    countryCode: 'MK',
    country: 'Macedonia',
  },
  {
    citizenId: 131,
    countryCode: 'MG',
    country: 'Madagascar',
  },
  {
    citizenId: 132,
    countryCode: 'MW',
    country: 'Malawi',
  },
  {
    citizenId: 133,
    countryCode: 'MY',
    country: 'Malaysia',
  },
  {
    citizenId: 134,
    countryCode: 'MV',
    country: 'Maldives',
  },
  {
    citizenId: 135,
    countryCode: 'ML',
    country: 'Mali',
  },
  {
    citizenId: 136,
    countryCode: 'MT',
    country: 'Malta',
  },
  {
    citizenId: 137,
    countryCode: 'MH',
    country: 'Marshall Islands',
  },
  {
    citizenId: 138,
    countryCode: 'MQ',
    country: 'Martinique',
  },
  {
    citizenId: 139,
    countryCode: 'MR',
    country: 'Mauritania',
  },
  {
    citizenId: 140,
    countryCode: 'MU',
    country: 'Mauritius',
  },
  {
    citizenId: 141,
    countryCode: 'TY',
    country: 'Mayotte',
  },
  {
    citizenId: 142,
    countryCode: 'MX',
    country: 'Mexico',
  },
  {
    citizenId: 143,
    countryCode: 'FM',
    country: 'Micronesia, Federated States of',
  },
  {
    citizenId: 144,
    countryCode: 'MD',
    country: 'Moldova, Republic of',
  },
  {
    citizenId: 145,
    countryCode: 'MC',
    country: 'Monaco',
  },
  {
    citizenId: 146,
    countryCode: 'MN',
    country: 'Mongolia',
  },
  {
    citizenId: 147,
    countryCode: 'ME',
    country: 'Montenegro',
  },
  {
    citizenId: 148,
    countryCode: 'MS',
    country: 'Montserrat',
  },
  {
    citizenId: 149,
    countryCode: 'MA',
    country: 'Morocco',
  },
  {
    citizenId: 150,
    countryCode: 'MZ',
    country: 'Mozambique',
  },
  {
    citizenId: 151,
    countryCode: 'MM',
    country: 'Myanmar',
  },
  {
    citizenId: 152,
    countryCode: 'NA',
    country: 'Namibia',
  },
  {
    citizenId: 153,
    countryCode: 'NR',
    country: 'Nauru',
  },
  {
    citizenId: 154,
    countryCode: 'NP',
    country: 'Nepal',
  },
  {
    citizenId: 155,
    countryCode: 'NL',
    country: 'Netherlands',
  },
  {
    citizenId: 156,
    countryCode: 'AN',
    country: 'Netherlands Antilles',
  },
  {
    citizenId: 157,
    countryCode: 'NC',
    country: 'New Caledonia',
  },
  {
    citizenId: 158,
    countryCode: 'NZ',
    country: 'New Zealand',
  },
  {
    citizenId: 159,
    countryCode: 'NI',
    country: 'Nicaragua',
  },
  {
    citizenId: 160,
    countryCode: 'NE',
    country: 'Niger',
  },
  {
    citizenId: 161,
    countryCode: 'NG',
    country: 'Nigeria',
  },
  {
    citizenId: 162,
    countryCode: 'NU',
    country: 'Niue',
  },
  {
    citizenId: 163,
    countryCode: 'NF',
    country: 'Norfolk Island',
  },
  {
    citizenId: 164,
    countryCode: 'MP',
    country: 'Northern Mariana Islands',
  },
  {
    citizenId: 165,
    countryCode: 'NO',
    country: 'Norway',
  },
  {
    citizenId: 166,
    countryCode: 'OM',
    country: 'Oman',
  },
  {
    citizenId: 167,
    countryCode: 'PK',
    country: 'Pakistan',
  },
  {
    citizenId: 168,
    countryCode: 'PW',
    country: 'Palau',
  },
  {
    citizenId: 169,
    countryCode: 'PS',
    country: 'Palestine',
  },
  {
    citizenId: 170,
    countryCode: 'PA',
    country: 'Panama',
  },
  {
    citizenId: 171,
    countryCode: 'PG',
    country: 'Papua New Guinea',
  },
  {
    citizenId: 172,
    countryCode: 'PY',
    country: 'Paraguay',
  },
  {
    citizenId: 173,
    countryCode: 'PE',
    country: 'Peru',
  },
  {
    citizenId: 174,
    countryCode: 'PH',
    country: 'Philippines',
  },
  {
    citizenId: 175,
    countryCode: 'PN',
    country: 'Pitcairn',
  },
  {
    citizenId: 176,
    countryCode: 'PL',
    country: 'Poland',
  },
  {
    citizenId: 177,
    countryCode: 'PT',
    country: 'Portugal',
  },
  {
    citizenId: 178,
    countryCode: 'PR',
    country: 'Puerto Rico',
  },
  {
    citizenId: 179,
    countryCode: 'QA',
    country: 'Qatar',
  },
  {
    citizenId: 180,
    countryCode: 'RE',
    country: 'Reunion',
  },
  {
    citizenId: 181,
    countryCode: 'RO',
    country: 'Romania',
  },
  {
    citizenId: 182,
    countryCode: 'RU',
    country: 'Russian Federation',
  },
  {
    citizenId: 183,
    countryCode: 'RW',
    country: 'Rwanda',
  },
  {
    citizenId: 184,
    countryCode: 'KN',
    country: 'Saint Kitts and Nevis',
  },
  {
    citizenId: 185,
    countryCode: 'LC',
    country: 'Saint Lucia',
  },
  {
    citizenId: 186,
    countryCode: 'VC',
    country: 'Saint Vincent and the Grenadines',
  },
  {
    citizenId: 187,
    countryCode: 'WS',
    country: 'Samoa',
  },
  {
    citizenId: 188,
    countryCode: 'SM',
    country: 'San Marino',
  },
  {
    citizenId: 189,
    countryCode: 'ST',
    country: 'Sao Tome and Principe',
  },
  {
    citizenId: 190,
    countryCode: 'SA',
    country: 'Saudi Arabia',
  },
  {
    citizenId: 191,
    countryCode: 'SN',
    country: 'Senegal',
  },
  {
    citizenId: 192,
    countryCode: 'RS',
    country: 'Serbia',
  },
  {
    citizenId: 193,
    countryCode: 'SC',
    country: 'Seychelles',
  },
  {
    citizenId: 194,
    countryCode: 'SL',
    country: 'Sierra Leone',
  },
  {
    citizenId: 195,
    countryCode: 'SG',
    country: 'Singapore',
  },
  {
    citizenId: 196,
    countryCode: 'SK',
    country: 'Slovakia',
  },
  {
    citizenId: 197,
    countryCode: 'SI',
    country: 'Slovenia',
  },
  {
    citizenId: 198,
    countryCode: 'SB',
    country: 'Solomon Islands',
  },
  {
    citizenId: 199,
    countryCode: 'SO',
    country: 'Somalia',
  },
  {
    citizenId: 200,
    countryCode: 'ZA',
    country: 'South Africa',
  },
  {
    citizenId: 201,
    countryCode: 'GS',
    country: 'South Georgia South Sandwich Islands',
  },
  {
    citizenId: 202,
    countryCode: 'ES',
    country: 'Spain',
  },
  {
    citizenId: 203,
    countryCode: 'LK',
    country: 'Sri Lanka',
  },
  {
    citizenId: 204,
    countryCode: 'SH',
    country: 'St. Helena',
  },
  {
    citizenId: 205,
    countryCode: 'PM',
    country: 'St. Pierre and Miquelon',
  },
  {
    citizenId: 206,
    countryCode: 'SD',
    country: 'Sudan',
  },
  {
    citizenId: 207,
    countryCode: 'SR',
    country: 'Suriname',
  },
  {
    citizenId: 208,
    countryCode: 'SJ',
    country: 'Svalbard and Jan Mayen Islands',
  },
  {
    citizenId: 209,
    countryCode: 'SZ',
    country: 'Swaziland',
  },
  {
    citizenId: 210,
    countryCode: 'SE',
    country: 'Sweden',
  },
  {
    citizenId: 211,
    countryCode: 'CH',
    country: 'Switzerland',
  },
  {
    citizenId: 212,
    countryCode: 'SY',
    country: 'Syrian Arab Republic',
  },
  {
    citizenId: 213,
    countryCode: 'TW',
    country: 'Taiwan',
  },
  {
    citizenId: 214,
    countryCode: 'TJ',
    country: 'Tajikistan',
  },
  {
    citizenId: 215,
    countryCode: 'TZ',
    country: 'Tanzania, United Republic of',
  },
  {
    citizenId: 216,
    countryCode: 'TH',
    country: 'Thailand',
  },
  {
    citizenId: 217,
    countryCode: 'TG',
    country: 'Togo',
  },
  {
    citizenId: 218,
    countryCode: 'TK',
    country: 'Tokelau',
  },
  {
    citizenId: 219,
    countryCode: 'TO',
    country: 'Tonga',
  },
  {
    citizenId: 220,
    countryCode: 'TT',
    country: 'Trinidad and Tobago',
  },
  {
    citizenId: 221,
    countryCode: 'TN',
    country: 'Tunisia',
  },
  {
    citizenId: 222,
    countryCode: 'TR',
    country: 'Turkey',
  },
  {
    citizenId: 223,
    countryCode: 'TM',
    country: 'Turkmenistan',
  },
  {
    citizenId: 224,
    countryCode: 'TC',
    country: 'Turks and Caicos Islands',
  },
  {
    citizenId: 225,
    countryCode: 'TV',
    country: 'Tuvalu',
  },
  {
    citizenId: 226,
    countryCode: 'UG',
    country: 'Uganda',
  },
  {
    citizenId: 227,
    countryCode: 'UA',
    country: 'Ukraine',
  },
  {
    citizenId: 228,
    countryCode: 'AE',
    country: 'United Arab Emirates',
  },
  {
    citizenId: 229,
    countryCode: 'GB',
    country: 'United Kingdom',
  },
  {
    citizenId: 230,
    countryCode: 'US',
    country: 'United States',
  },
  {
    citizenId: 231,
    countryCode: 'UM',
    country: 'United States minor outlying islands',
  },
  {
    citizenId: 232,
    countryCode: 'UY',
    country: 'Uruguay',
  },
  {
    citizenId: 233,
    countryCode: 'UZ',
    country: 'Uzbekistan',
  },
  {
    citizenId: 234,
    countryCode: 'VU',
    country: 'Vanuatu',
  },
  {
    citizenId: 235,
    countryCode: 'VA',
    country: 'Vatican City State',
  },
  {
    citizenId: 236,
    countryCode: 'VE',
    country: 'Venezuela',
  },
  {
    citizenId: 237,
    countryCode: 'VN',
    country: 'Vietnam',
  },
  {
    citizenId: 238,
    countryCode: 'VG',
    country: 'Virgin Islands (British)',
  },
  {
    citizenId: 239,
    countryCode: 'VI',
    country: 'Virgin Islands (U.S.)',
  },
  {
    citizenId: 240,
    countryCode: 'WF',
    country: 'Wallis and Futuna Islands',
  },
  {
    citizenId: 241,
    countryCode: 'EH',
    country: 'Western Sahara',
  },
  {
    citizenId: 242,
    countryCode: 'YE',
    country: 'Yemen',
  },
  {
    citizenId: 243,
    countryCode: 'ZR',
    country: 'Zaire',
  },
  {
    citizenId: 244,
    countryCode: 'ZM',
    country: 'Zambia',
  },
  {
    citizenId: 245,
    countryCode: 'ZW',
    country: 'Zimbabwe',
  },
];
